// Firebase v11+ modular SDK
// https://firebase.google.com/docs/web/setup
import { initializeApp } from 'firebase/app';
import { getAnalytics } from 'firebase/analytics';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getFunctions } from 'firebase/functions';
import { firebaseConfig } from './config/keys';

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize services
const analytics = getAnalytics(app);
const firestore = getFirestore(app);
const auth = getAuth(app);
const functions = getFunctions(app);

export { app, analytics, firestore, auth, functions };
